/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Jobs_SelectedInputs */



/**
* | output |
* | --- |
* | "{count} jobs selected" |
*
* @param {Jobs_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const jobs_selected = /** @type {((inputs: Jobs_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} emplois sélectionnés`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Jobs ausgewählt`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} posti di lavoro selezionati`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} выбраны вакансии`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} trabajos seleccionados`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已选择 ${i?.count} 工作`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} ジョブが選択されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} नौकरियां चयनित`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} vagas selecionadas`)
	return /** @type {LocalizedString} */ (`${i?.count} jobs selected`)
});